export default function LocalTrust() {
  return (
    <section className="py-16 bg-gradient-to-r from-teal-50 to-cyan-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <p className="text-xl text-gray-700 font-medium">
          Supporting businesses across Nassau & Suffolk County
        </p>
      </div>
    </section>
  );
}
